<template>
    <div>

        <div class="row">
            <input-text @change="calcularCampos()" class="col-12 col-md-6" label="Ano" type="number" :min="1960" :max-length="4" v-model="form.ano" ref="ano" required/>
            <input-select @input="calcularCampos()" class="col-12 col-md-6" label="Mês" v-model="form.mes" :options="options.meses" ref="mes" required/>
        </div>
        <hr>
        <div class="row">

            <template v-for="receita,i in form.receitas">
                <div :key="i" class="col-12 row">
                    <input-select @input="calcularCampos()" :class="`col-${receita.tipo != 'OutrasReceitas' ? 8 : 4}`" label="Receita" :options="options.tipoReceita" v-model="receita.tipo" :ref="`receita${i}-tipo`" required>
                        <template #prepend>
                            <b-button class="mr-2" variant="flat-danger" @click="removerReceita(receita)">
                                <i class="fa-solid fa-trash"></i>
                            </b-button>
                        </template>
                    </input-select>
                    <input-text class="col-4" label="Descrição" v-model="receita.descricao" :ref="`receita${i}-descricao`" required v-if="receita.tipo == 'OutrasReceitas'"/>
                    <input-money class="col-4" label="Valor" v-model="receita.valor" @blur="calcularCampos()" :ref="`receita${i}-valor`" required></input-money>
                </div>
            </template>

            <div class="col-12">
                <b-button variant="info" size="sm" @click="adicionarReceita">
                    <i class="fa-solid fa-plus-circle mr-2"></i>
                    Adicionar receitas
                </b-button>
            </div>
        </div>
        <hr>
        <div class="row">
            <template v-for="deducao,i in form.deducoes">
                <div :key="i" class="col-12 row">
                    <input-select  @input="calcularCampos(true)" :class="`col-${deducao.tipo != 'OutrasDeducoes' ? 8 : 4}`" label="Dedução" :options="options.tipoDeducao" v-model="deducao.tipo" :ref="`deducao${i}-tipo`" required>
                        <template #prepend>
                            <b-button class="mr-2" variant="flat-danger" @click="removerDeducao(deducao)">
                                <i class="fa-solid fa-trash"></i>
                            </b-button>
                        </template>
                    </input-select>
                    <input-text class="col-4" label="Descrição" v-model="deducao.descricao" :ref="`deducao${i}-descricao`" required v-if="deducao.tipo == 'OutrasDeducoes'"/>
                    <input-money class="col-4" label="Valor" @blur="calcularCampos()" v-model="deducao.valor" :ref="`deducao${i}-valor`" required></input-money>
                </div>
            </template>

            <div class="col-12">
                <b-button variant="info" size="sm" @click="adicionarDeducao">
                    <i class="fa-solid fa-plus-circle mr-2"></i>
                    Adicionar deduções
                </b-button>
            </div>
        </div>
        <hr>
        <div>
            <div class="d-flex">
                <b-button size="sm" @click="editarValores" v-if="!form.editar">
                    <i class="fa-solid fa-edit mr-2"></i>
                    Editar valores
                </b-button>
            </div>
            <div class="row dashboard-rh">
                <card titulo="ROL bruta" :editar="form.editar" v-model="form.bruta"/>
                <card titulo="ROL Intermediária" :editar="form.editar" v-model="form.intermediaria"/>
                <card titulo="ROL final" :editar="form.editar" v-model="form.final"/>
            </div>
            <div class="row dashboard-rh">
                <card titulo="1% da ROL final" :editar="form.editar" v-model="form.destinacaoProgramaPD"/>
                <card titulo="CDE" :editar="form.editar" v-model="form.cde" v-if="empresaSelecionada.segmento != 'Distribuicao'"/>
                <card titulo="FNDCT" :editar="form.editar" v-model="form.fndct"/>
                <card titulo="MME" :editar="form.editar" v-model="form.mme"/>
                <card titulo="P&D ANEEL" :editar="form.editar" v-model="form.pd"/>
                <card titulo="PEE" :editar="form.editar" v-model="form.pee" v-if="empresaSelecionada.segmento == 'Distribuicao'"/>
            </div>
            <div v-if="empresaSelecionada.segmento == 'Distribuicao'" class="row dashboard-rh">
                <card titulo="PROCEL" :editar="form.editar" v-model="form.procel"/>
                <card titulo="CDE PD" :editar="form.editar" v-model="form.cdepd"/>
                <card titulo="CDE PEE" :editar="form.editar" v-model="form.cdepee"/>
            </div>
        </div>
    </div>
</template>
<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import InputMoney from "@/components/inputs/InputMoney";
import helpers from "@/common/utils/helpers";
import {FormMixin} from "@/common/mixins/FormMixin";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";
import MovimentacaoFinanceiraService from "@/common/services/movimentacao_financeira/movimentacao_financeira.service";
import cloneDeep from "lodash/cloneDeep";
import card from "./Card.vue"

export default {
    mixins: [FormMixin, AlertasMixin],
    components : {
        InputText,
        InputSelect,
        InputMoney,
        card
    },
    props : {
        form : {
            required : true,
        }
    },
    data : () => ({
        options : {
            meses : helpers.retornarMeses(),
            tipoReceita : helpers.TipoReceita,
            tipoDeducao : helpers.TipoDeducoes,
        },
        fatores : {
            fndct : 0,
            mme : 0,
            pd : 0,
            cde : 0,
            cde_pd : 0,
            cde_pee : 0,
            pee : 0,
            procel : 0,
        }
    }),
    methods : {
        editarValores(){
            this.form.editar = true;
            this.$forceUpdate();
        },
        adicionarReceita : function() {
            this.form.receitas.push({
                tipo : null,
                valor : 0,
                descricao : "",
                rolId : this.form.id
            });
        },
        salvarReceita : function(receita,i) {
            if(!this.validateState(`receita${i}-`))
                return false;
            this.confirmar("Deseja salvar a receita?").then( confirmado =>{
                if(!confirmado)
                    return false;

                let form = cloneDeep(receita);

                form.valor = helpers.removerValor(form.valor);
                form.rolId = this.form.id;

                MovimentacaoFinanceiraService.salvarReceita(form).then(response => {
                    if(!receita.id)
                        receita.id = response.data.data;
                    this.alertaSucesso("Receita salva com sucesso!");
                }).catch(() => {
                    this.alertaErro("Erro ao salvar receita!");
                });
                
            })
        },
        removerReceita : function(receita) {
            //if(!receita.id){
                this.form.receitas.splice(this.form.receitas.indexOf(receita), 1);
                this.calcularCampos(true);
                return;
            //}
            
            /*this.confirmar("Deseja remover a receita?").then( confirmado => {
                if(!confirmado)
                    return false;

                MovimentacaoFinanceiraService.removerReceita(receita.id).then(() => {
                    this.alertaSucesso("Receita removida com sucesso!");
                    this.form.receitas.splice(this.form.receitas.indexOf(receita), 1);
                    this.calcularCampos(true);
                }).catch(() => {
                    this.alertaErro("Erro ao remover receita!");
                });
            });*/
            
        },
        adicionarDeducao : function() {
            this.form.deducoes.push({
                tipo : null,
                valor : 0,
                descricao : "",
                rolId : this.form.id
            });
        },
        salvarDeducao : function(deducao,i) {
            if(!this.validateState(`deducao${i}-`))
                return false;
            this.confirmar("Deseja salvar a deducao?").then( confirmado =>{
                if(!confirmado)
                    return false;

                let form = cloneDeep(deducao);

                form.valor = helpers.removerValor(form.valor);
                form.rolId = this.form.id;

                MovimentacaoFinanceiraService.salvarDeducao(form).then(response => {
                    if(!deducao.id)
                        deducao.id = response.data.data;
                    this.alertaSucesso("Dedução salva com sucesso!");
                }).catch(() => {
                    this.alertaErro("Erro ao salvar dedução!");
                });
                
            })
        },
        removerDeducao : function(deducao) {
            //if(!deducao.id){
                this.form.deducoes.splice(this.form.deducoes.indexOf(deducao), 1);
                this.calcularCampos(true);
                return;
            //}
            
            /*this.confirmar("Deseja remover a deducao?").then( confirmado => {
                if(!confirmado)
                    return false;

                MovimentacaoFinanceiraService.removerDeducao(deducao.id).then(() => {
                    this.alertaSucesso("Dedução removida com sucesso!");
                    this.form.deducoes.splice(this.form.deducoes.indexOf(deducao), 1);
                    this.calcularCampos(true);
                }).catch(() => {
                    this.alertaErro("Erro ao remover dedução!");
                });
            });*/
        },
        calcularFatores : function(){
            if(this.empresaSelecionada.segmento == 'Distribuicao'){
                if(this.form.ano < 2003 || (this.form.ano == 2003 && this.form.mes < 11)){
                    this.fatores = {
                        fndct : 0.25,
                        mme : 0,
                        pd : 0.25,
                        cde : 0,
                        cde_pd : 0,
                        cde_pee : 0,
                        pee : 0.5,
                        procel : 0,
                    }
                }
                if((this.form.ano == 2003 && this.form.mes == 12) || (this.form.ano == 2004 && this.form.mes <= 3)){
                    this.fatores = {
                        fndct : 0.2,
                        mme : 0.1,
                        pd : 0.2,
                        cde : 0,
                        cde_pd : 0,
                        cde_pee : 0,
                        pee : 0.5,
                        procel : 0,
                    }
                }
                if((this.form.ano == 2004 && this.form.mes >= 4) || (this.form.ano <= 2011 && this.form.ano >= 2005) || (this.form.ano == 2012 && this.form.mes <= 7)){
                    this.fatores = {
                        fndct : 0.4,
                        mme : 0.2,
                        pd : 0.4,
                        cde : 0,
                        cde_pd : 0,
                        cde_pee : 0,
                        pee : 0.5,
                        procel : 0,
                    }
                }
                if((this.form.ano == 2012 && this.form.mes >= 8) || (this.form.ano <= 2016 && this.form.ano >= 2013)){
                    this.fatores = {
                        fndct : 0.2,
                        mme : 0.1,
                        pd : 0.2,
                        cde : 0,
                        cde_pd : 0,
                        cde_pee : 0,
                        pee : 0.5,
                        procel : 0,
                    }
                }
                if((this.form.ano == 2017 && this.form.mes >= 1) || (this.form.ano <= 2019 && this.form.ano >= 2017) || (this.form.ano == 2020 && this.form.mes <= 8)){
                    this.fatores = {
                        fndct : 0.4,
                        mme : 0.2,
                        pd : 0.4,
                        cde : 0,
                        cde_pd : 0,
                        cde_pee : 0,
                        pee : 0.5,
                        procel : 0,
                    }
                }
                if((this.form.ano == 2020 && this.form.mes >= 9) || this.form.ano > 2020){
                    this.fatores = {
                        fndct : 0.2,
                        mme : 0.1,
                        pd : 0.2,
                        cde : 0,
                        cde_pd : 0.2,
                        cde_pee : 0.4,
                        pee : 0.4,
                        procel : 0.1,
                    }
                }
            }else{
                //comeca aqui geracao e outros
                if(this.form.ano < 2003 || (this.form.ano == 2003 && this.form.mes < 11)){
                    this.fatores = {
                        fndct : 0.5,
                        mme : 0,
                        pd : 0.5,
                        cde : 0,
                        cde_pd : 0,
                        cde_pee : 0,
                        pee : 0,
                        procel : 0,
                    }
                }
                if((this.form.ano == 2003 && this.form.mes == 12) || (this.form.ano == 2004 && this.form.mes <= 3)){
                    this.fatores = {
                        fndct : 0.5,
                        mme : 0.25,
                        pd : 0.25,
                        cde : 0,
                        cde_pd : 0,
                        cde_pee : 0,
                        pee : 0,
                        procel : 0,
                    }
                }
                if((this.form.ano == 2004 && this.form.mes >= 4) || (this.form.ano <= 2011 && this.form.ano >= 2005) || (this.form.ano == 2012 && this.form.mes <= 7)){
                    this.fatores = {
                        fndct : 0.4,
                        mme : 0.2,
                        pd : 0.4,
                        cde : 0,
                        cde_pd : 0,
                        cde_pee : 0,
                        pee : 0,
                        procel : 0,
                    }
                }
                if((this.form.ano == 2012 && this.form.mes >= 8) || (this.form.ano <= 2016 && this.form.ano >= 2013)){
                    this.fatores = {
                        fndct : 0.4,
                        mme : 0.2,
                        pd : 0.4,
                        cde : 0,
                        cde_pd : 0,
                        cde_pee : 0,
                        pee : 0,
                        procel : 0,
                    }
                }
                if((this.form.ano == 2017 && this.form.mes >= 1) || (this.form.ano <= 2019 && this.form.ano >= 2017) || (this.form.ano == 2020 && this.form.mes <= 8)){
                    this.fatores = {
                        fndct : 0.4,
                        mme : 0.2,
                        pd : 0.4,
                        cde : 0,
                        cde_pd : 0,
                        cde_pee : 0,
                        pee : 0,
                        procel : 0,
                    }
                }
                if((this.form.ano == 2020 && this.form.mes >= 9) || this.form.ano > 2020){
                    this.fatores = {
                        fndct : 0.4,
                        mme : 0.2,
                        pd : 0.4,
                        cde : 0.4,
                        cde_pd : 0,
                        cde_pee : 0,
                        pee : 0,
                        procel : 0,
                    }
                }
            }
        },
        calcularCampos : function(){  
            if(this.form.editar)
                return;          
            this.calcularFatores();
            
            let rolBruta = this.form.receitas.reduce((total, receita) => {
                return total + parseFloat(helpers.removerValor(`${receita.valor}`));
            }, 0)

            let totalDeducoes =  this.form.deducoes.filter(el => el.tipo != 'EncargosPD').reduce((total, receita) => {
                return total + parseFloat(helpers.removerValor(`${receita.valor}`));
            }, 0);

            let rolIntermediaria = rolBruta - totalDeducoes;

            let rolFinal = (this.form.ano < 2006 || (this.form.ano == 2006 && this.form.mes <= 4)) ? 
                rolIntermediaria :
                rolIntermediaria / 1.01;

            let rol1Porcento = rolFinal * 0.01;

            this.form.bruta = helpers.formatarValor(rolBruta);
            this.form.intermediaria = helpers.formatarValor(rolIntermediaria);
            this.form.final = helpers.formatarValor(rolFinal);

            this.form.destinacaoProgramaPD = helpers.formatarValor(rol1Porcento);
            this.form.fndct = helpers.formatarValor(rol1Porcento * this.fatores.fndct);
            this.form.mme = helpers.formatarValor(rol1Porcento * this.fatores.mme);
            this.form.pd = helpers.formatarValor(
                (rol1Porcento * this.fatores.pd ) * 
                ((this.form.ano >= 2021) || (this.form.mes >= 9 && this.form.ano == 2020) ? 0.7 : 1)
            );
            this.form.cde = helpers.formatarValor(
                (this.form.ano >= 2021 && this.form.ano <= 2025) || (this.form.mes >= 9 && this.form.ano >= 2020 && this.form.ano <= 2025) ? 
                (rol1Porcento *  this.fatores.cde ) * 0.3 : 0
            );
            this.form.cdepd = helpers.formatarValor(
                (
                    (this.form.ano >= 2021 && this.form.ano <= 2025) || (this.form.mes >= 9 && this.form.ano >= 2020 && this.form.ano  <= 2025) ? 
                    (rol1Porcento * this.fatores.cde_pd) * 0.3 : 0
                )
            );
            this.form.cdepee = helpers.formatarValor(
                (
                    (this.form.ano >= 2021 && this.form.ano <= 2025) || (this.form.mes >= 9 && this.form.ano >= 2020 && this.form.ano  <= 2025) ? 
                    (rol1Porcento * this.fatores.cde_pee) * 0.3 : 0 
                )
            );
            this.form.pee = helpers.formatarValor((rol1Porcento * this.fatores.pee) * ((this.form.ano >= 2021) || (this.form.mes >= 9 && this.form.ano == 2020) ? 0.7 : 1));

            this.form.procel = helpers.formatarValor(
                (
                    (this.form.ano >= 2021 && this.form.ano <= 2025) || (this.form.mes >= 9 && this.form.ano >= 2020 && this.form.ano  <= 2025) ? 
                    rol1Porcento * this.fatores.procel : 0
                )
            );            
        }
    },
    
    computed : {
        empresaSelecionada : function(){
            return this.$store.state.app.selectedCompanyObj;
        },
    },
}
</script>
<style>
    .border-left:first-child{
        border:none !important;
    }
    .border-left{
        border: none;
    }
    @media (min-width: 768px){
        .border-left{
            border-left : 1px solid #e5e5e5;
        }
    }
</style>